<div class="flex flex-col py-8 justify-center">
  <div class="container-padding max-w-screen-desktop mx-auto w-full">

    <div class="grid grid-cols-1 tablet:grid-cols-12 gap-16">
      <div class="tablet:col-span-5 col-span-1">
        <div class="py-6 px-6 shadow rounded-2xl sm:px-10 my-4 border border-4 border-[var(--black)] bg-[var(--white)]">
          <h2 class="uppercase text-[42px]/[65px] font-normal text-[var(--dark-orange)]">
            {{ 'login.title' | translate }}
          </h2>

          <div class="w-full border-t border-dotted mb-6 mt-2"></div>

          <form [formGroup]="loginForm" (submit)="onSubmit()">
            <div class="flex flex-col gap-6">
              <app-input
                [control]="loginForm.controls['email']"
                inputId="email"
                type="email"
                autocomplete="email"
                [label]="'login.email' | translate"
                placeholder="usuario@correo.com"
              ></app-input>
              <app-input
                [control]="loginForm.controls['password']"
                inputId="password"
                type="password"
                autocomplete="current-password"
                [label]="'login.password' | translate"
                placeholder="******"
              ></app-input>
            </div>

            <div class="mt-8">
              <app-button [submit]="true" [disabled]="isLoading" [text]="isLoading ? ('login.loading' | translate) : ('login.submit' | translate)" [fullWidth]="true"></app-button>
            </div>

            <div *ngIf="errorMessage" class="mt-4 font-bold text-[14px]/[14px] text-center" style="color: red;">
              {{ errorMessage }}
            </div>
          </form>

          <!-- Social login -->
          <div class="mt-6">
            <div class="flex items-center gap-2 mb-4">
              <div class="flex-1 border-t border-gray-300"></div>
              <span class="text-gray-500 text-sm uppercase font-normal">{{ 'login.orContinueWith' | translate }}</span>
              <div class="flex-1 border-t border-gray-300"></div>
            </div>

            <div class="flex justify-center gap-3">
              <!-- Google -->
              <button
                type="button"
                (click)="onSocialLogin('google')"
                [disabled]="!!socialLoginLoading"
                title="Continuar con Google"
                class="w-14 h-14 rounded-full border-2 border-gray-200 hover:border-gray-400 bg-white flex items-center justify-center transition-all duration-300 disabled:opacity-50"
              >
                <svg *ngIf="socialLoginLoading !== 'google'" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0,0,256,256" class="w-8 h-8"><g transform="translate(-24.32,-24.32) scale(1.19,1.19)"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.33333,5.33333)"><path d="M43.611,20.083h-1.611v-0.083h-18v8h11.303c-1.649,4.657 -6.08,8 -11.303,8c-6.627,0 -12,-5.373 -12,-12c0,-6.627 5.373,-12 12,-12c3.059,0 5.842,1.154 7.961,3.039l5.657,-5.657c-3.572,-3.329 -8.35,-5.382 -13.618,-5.382c-11.045,0 -20,8.955 -20,20c0,11.045 8.955,20 20,20c11.045,0 20,-8.955 20,-20c0,-1.341 -0.138,-2.65 -0.389,-3.917z" fill="#ffc107"></path><path d="M6.306,14.691l6.571,4.819c1.778,-4.402 6.084,-7.51 11.123,-7.51c3.059,0 5.842,1.154 7.961,3.039l5.657,-5.657c-3.572,-3.329 -8.35,-5.382 -13.618,-5.382c-7.682,0 -14.344,4.337 -17.694,10.691z" fill="#ff3d00"></path><path d="M24,44c5.166,0 9.86,-1.977 13.409,-5.192l-6.19,-5.238c-2.008,1.521 -4.504,2.43 -7.219,2.43c-5.202,0 -9.619,-3.317 -11.283,-7.946l-6.522,5.025c3.31,6.477 10.032,10.921 17.805,10.921z" fill="#4caf50"></path><path d="M43.611,20.083h-1.611v-0.083h-18v8h11.303c-0.792,2.237 -2.231,4.166 -4.087,5.571c0.001,-0.001 0.002,-0.001 0.003,-0.002l6.19,5.238c-0.438,0.398 6.591,-4.807 6.591,-14.807c0,-1.341 -0.138,-2.65 -0.389,-3.917z" fill="#1976d2"></path></g></g></g></svg>
                <span *ngIf="socialLoginLoading === 'google'" class="w-6 h-6 border-2 border-gray-400 border-t-transparent rounded-full animate-spin"></span>
              </button>

              <!-- Facebook -->
              <!-- <button
                type="button"
                (click)="onSocialLogin('facebook')"
                [disabled]="!!socialLoginLoading"
                title="Continuar con Facebook"
                class="w-14 h-14 rounded-full border-2 border-gray-200 hover:border-blue-500 bg-white flex items-center justify-center transition-all duration-300 disabled:opacity-50"
              >
                <svg *ngIf="socialLoginLoading !== 'facebook'" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0,0,256,256" class="w-8 h-8"><g transform="translate(-32,-32) scale(1.25,1.25)"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.33333,5.33333)"><path d="M24,5c-10.49341,0 -19,8.50659 -19,19c0,10.49341 8.50659,19 19,19c10.49341,0 19,-8.50659 19,-19c0,-10.49341 -8.50659,-19 -19,-19z" fill="#039be5"></path><path d="M26.572,29.036h4.917l0.772,-4.995h-5.69v-2.73c0,-2.075 0.678,-3.915 2.619,-3.915h3.119v-4.359c-0.548,-0.074 -1.707,-0.236 -3.897,-0.236c-4.573,0 -7.254,2.415 -7.254,7.917v3.323h-4.701v4.995h4.701v13.729c0.931,0.14 1.874,0.235 2.842,0.235c0.875,0 1.729,-0.08 2.572,-0.194z" fill="#ffffff"></path></g></g></g></svg>
                <span *ngIf="socialLoginLoading === 'facebook'" class="w-6 h-6 border-2 border-gray-400 border-t-transparent rounded-full animate-spin"></span>
              </button> -->

              <!-- Apple -->
              <button
                type="button"
                (click)="onSocialLogin('apple')"
                [disabled]="!!socialLoginLoading"
                title="Continuar con Apple"
                class="w-14 h-14 rounded-full border-2 border-gray-200 hover:border-gray-600 bg-white flex items-center justify-center transition-all duration-300 disabled:opacity-50"
              >
                <svg *ngIf="socialLoginLoading !== 'apple'" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0,0,256,256" class="w-8 h-8"><g transform="translate(-8.96,-8.96) scale(1.07,1.07)"><g fill="#000000" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="translate(1.20932,5.11905) scale(5.12,5.12)"><path d="M44.52734,34.75c-1.07812,2.39453 -1.59766,3.46484 -2.98437,5.57813c-1.94141,2.95313 -4.67969,6.64063 -8.0625,6.66406c-3.01172,0.02734 -3.78906,-1.96484 -7.87891,-1.92969c-4.08594,0.01953 -4.9375,1.96875 -7.95312,1.9375c-3.38672,-0.03125 -5.97656,-3.35156 -7.91797,-6.30078c-5.42969,-8.26953 -6.00391,-17.96484 -2.64844,-23.12109c2.375,-3.65625 6.12891,-5.80469 9.65625,-5.80469c3.59375,0 5.85156,1.97266 8.82031,1.97266c2.88281,0 4.63672,-1.97656 8.79297,-1.97656c3.14063,0 6.46094,1.71094 8.83594,4.66406c-7.76562,4.25781 -6.50391,15.34766 1.33984,18.31641zM31.19531,8.46875c1.51172,-1.94141 2.66016,-4.67969 2.24219,-7.46875c-2.46484,0.16797 -5.34766,1.74219 -7.03125,3.78125c-1.52734,1.85938 -2.79297,4.61719 -2.30078,7.28516c2.69141,0.08594 5.47656,-1.51953 7.08984,-3.59766z"></path></g></g></g></svg>
                <span *ngIf="socialLoginLoading === 'apple'" class="w-6 h-6 border-2 border-gray-400 border-t-transparent rounded-full animate-spin"></span>
              </button>
            </div>

            <div *ngIf="socialLoginError" class="mt-4 font-bold text-[14px]/[14px] text-center" style="color: red;">
              {{ socialLoginError }}
            </div>
          </div>

          <div class="mt-6 flex flex-col items-center gap-3">
            <a routerLink="/forgot-password" class="uppercase font-bold text-[var(--black)] text-[14px]/[14px]">
              {{ 'login.forgotPassword' | translate }}
            </a>

            <a *ngIf="showResendVerification" routerLink="/resend-verification-email" class="uppercase font-bold text-[var(--dark-orange)] text-[14px]/[14px]">
              {{ 'login.resendVerification' | translate }}
            </a>

            <div class="mt-2">
              <app-button routerLink="/register" [queryParamsHandling]="'preserve'" [text]="'login.register' | translate" styleType="secondary" [fullWidth]="false"></app-button>
            </div>
          </div>

        </div>
      </div>

      <div class="tablet:col-span-7 col-span-1 gap-12">
        <div class="flex flex-col mobile-m:flex-row gap-3">
          <div class="flex justify-center">
            <img src="assets/mascota.webp" alt="Drinkhopping hoppinsito" class="max-w-[200px]"/>
          </div>

          <div class="flex flex-col justify-between mobile-m:flex-row mobile-m:items-end gap-12 mt-8">
            <div class="text-left">
              <h3 class="uppercase text-[60px]/[60px]" style="font-weight: 400;">
                {{ 'login.experience' | translate }}
              </h3>
            </div>
          </div>
        </div>

        <app-busca-redime-vive class="w-full"></app-busca-redime-vive>

        <div class="mt-10">
          <p class="text-[12px]/[18px] text-black font-normal">{{ 'login.joinUs' | translate }}</p>
        </div>
      </div>
    </div>

  </div>
</div>
